import { coreService } from 'network-utils';
import { useQuery } from 'react-query';

export const getNewCourses = 'fetch-new-courses';
export const getDiscoverContent = 'fetch-discover-content';

export const useGetNewCourses = (token: string) => {
    return useQuery([getNewCourses], () => coreService.discoverApi.newCourses(token), {
        keepPreviousData: true,
        cacheTime: 0,
        enabled: !!token
    });
};

export const useGetDiscoverContent = (token: string, options: GetDiscoverContentOptions) => {
    const { sort, tags, category, limit, offset, contentTypes } = options || {};

    return useQuery(
        [getDiscoverContent, token, limit, offset, sort, tags, category, contentTypes],
        () =>
            coreService.discoverApi.content(token, {
                limit,
                offset,
                sort,
                tags,
                category,
                contentTypes
            }),
        {
            keepPreviousData: true,
            cacheTime: 0,
            enabled: !!token
        }
    );
};

interface GetDiscoverContentOptions {
    sort?: string;
    offset?: number;
    limit?: number;
    tags?: string[];
    category?: string;
    contentTypes?: string[];
}
